import { defineNotificationCategory, extractRelativeActionUrl } from './types';

const recommendationMovePills = (): string[] => ['Recommendation'];

export const recommendationAssignedDescriptor = defineNotificationCategory(
  'recommendation_assigned',
  { actionUrl: (data) => extractRelativeActionUrl(data.actionUrl), pills: recommendationMovePills },
);

export const recommendationCompletedDescriptor = defineNotificationCategory(
  'recommendation_completed',
  { actionUrl: (data) => extractRelativeActionUrl(data.actionUrl), pills: recommendationMovePills },
);

export const recommendationDismissedDescriptor = defineNotificationCategory(
  'recommendation_dismissed',
  { actionUrl: (data) => extractRelativeActionUrl(data.actionUrl), pills: recommendationMovePills },
);

export const recommendationReopenedDescriptor = defineNotificationCategory(
  'recommendation_reopened',
  { actionUrl: (data) => extractRelativeActionUrl(data.actionUrl), pills: recommendationMovePills },
);

export const recommendationRestoredDescriptor = defineNotificationCategory(
  'recommendation_restored',
  { actionUrl: (data) => extractRelativeActionUrl(data.actionUrl), pills: recommendationMovePills },
);

export const recommendationUnassignedDescriptor = defineNotificationCategory(
  'recommendation_unassigned',
  { actionUrl: (data) => extractRelativeActionUrl(data.actionUrl), pills: recommendationMovePills },
);
